import AutocompleteCacheWorker from 'common/data/autocomplete/cache/.worker';

export function AutocompleteCacheWorkerFactory(): Worker {
  return AutocompleteCacheWorker
    ? new AutocompleteCacheWorker()
    : // TS workaround for unit tests
      (Worker as any);
}
